export default __webpack_public_path__ + "static/media/micro.ddb6b6d6.jpg";